import React from 'react';
import Entry from '../entry';
import { Flex, Text } from 'rebass';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

export default () => {
  const title = 'Linux Path';
  const hints = [
  '[SugarPlum Mary] Green words matter, files must be found, and the terminal\'s $PATH matters.'
];
  const assignment = `Oh me oh my - I need some help!
I need to review some files in my Linux terminal, but I can't get a file listing.
I know the command is ls, but it's really acting up.
Do you think you could help me out? As you work on this, think about these questions:
Do the words in green have special significance?
How can I find a file with a specific name?
What happens if there are multiple executables with the same name in my $PATH?`;
  const data = useStaticQuery(graphql`
    query {
      cranPath: file(relativePath: { eq: "cranPath.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      pathStart: file(relativePath: { eq: "pathStart.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      pathStep1: file(relativePath: { eq: "pathStep1.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      pathStep2: file(relativePath: { eq: "pathStep2.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      pathArt1: file(relativePath: { eq: "pathArt1.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      pathArt2: file(relativePath: { eq: "pathArt2.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      pathExplore: file(relativePath: { eq: "pathExplore.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }


    }
  `);
  const extra = (
    <>
    <Img fluid={data.cranPath.childImageSharp.fluid}
            style={{ margin: 0,  maxHeight: '35vh', width: '72vw' }}
            imgStyle={{ objectFit: 'contain' }}
    />
    <Text mb={1} fontSize='13px' alignSelf='center'>Location: Hermey Hall Lobby</Text>
    </>
  );

  return (
    <Entry
      title={title}
      hints={hints}
      extra={extra}
      assignment={assignment}
    >
      <Text my={2}>The ASCII art at the starting screen is beautiful. </Text>
      <Img fluid={data.pathStart.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '75vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>We are already in the <code>home</code> folder. Let's see what's wrong with <code>ls</code> and which binary is used.</Text>
      <Img fluid={data.pathStep1.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '15vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>That is an odd location for the <code>ls</code> binary. The <code>$PATH</code> forces to call anything at <code>/usr/local/bin</code> first before checking other locations. No worries, we will explicitely call <code>ls</code> from the <code>bin</code> folder.</Text>
      <Img fluid={data.pathStep2.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '25vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>Now that we know it works, let's explore some more.</Text>
      <Img fluid={data.pathExplore.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '25vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>The Elves are very creative, no doubt!</Text>
      <Flex flexDirection='row' justifyContent='center' alignItems='flex-start'>
        <Img fluid={data.pathArt1.childImageSharp.fluid}
                style={{ margin: 0,  maxHeight: '70vh', width: '35vw' }}
                imgStyle={{ objectFit: 'contain' }}
        />
        <Img fluid={data.pathArt2.childImageSharp.fluid}
                style={{ margin: 0,  maxHeight: '70vh', width: '35vw' }}
                imgStyle={{ objectFit: 'contain' }}
        />
      </Flex>
    </Entry>
  )

};
